export enum CredentialApplicationDefinitionType {
  Initial = 'Initial',
  Renewal = 'Renewal',
  Reinstatement = 'Reinstatement',
  Specialty = 'Specialty',
}
